export default __webpack_public_path__ + "static/media/Slam3.9b07cd33.mp3";